import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {login, setToken} from "../../services";
import {useFormik} from "formik";
import {initialValues, validationSchema} from "../../utils/formsValidator/loginFormValidator";
import {useAuthAction} from "../../context/AuthContext";
import {pushToast} from "../../utils/pushToast";
import Loading from "../../components/Loading";
import Input from "../../components/Input";
import InputPassword from "../../components/InputPassword";

export default function Login() {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const setAuth = useAuthAction();

    const onSubmit = async (values) => {
        setIsLoading(true);
        try {
            const {userInfo, userPermission} = await login(values);
            if (userInfo.isSuccess) {
                setToken(userInfo?.data?.token)
                setAuth({userInfo: userInfo?.data, userPermission});
                navigate('/dashboard');
            } else {

                pushToast("نام کاربری و رمز عبور اشتباه است.", "error")
            }
            setIsLoading(false);
        } catch (ex) {
            console.log(ex)

            pushToast("نام کاربری و رمز عبور اشتباه است.", "error")
            setIsLoading(false);
        }
    }

    const formik = useFormik({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnMount: false,
        validateOnChange: true
    });

    return (
        <>
            <div className="container-xxl">
                <div className="authentication-wrapper authentication-basic container-p-y">
                    <div className="authentication-inner py-4">
                        <div className="card">
                            <div className="card-body">
                                <div className="app-brand justify-content-center">
                                    <img src="/logo.png" className={'w-100'}/>
                                </div>
                                <h4 className="mb-2">اطلاعات کاربری خود را وارد نمایید.</h4>

                                <form id="formAuthentication"
                                      className={`needs-validation mb-3 ${!formik.isValid ? "was-validated" : ""}`}
                                      noValidate={true} onSubmit={formik.handleSubmit}
                                      autoComplete="off"
                                >
                                    <div className="mb-3 position-relative">
                                        <Input
                                            type="text"
                                            className="text-start"
                                            dir="ltr"
                                            name="mobile"
                                            placeholder="شماره همراه خود را وارد کنید"
                                            autoComplete="off"
                                            label="شماره همراه"
                                            formik={formik}
                                        />
                                    </div>

                                    <div className="mb-3 form-password-toggle">
                                        <InputPassword
                                            className="text-start"
                                            dir="ltr"
                                            name="password"
                                            placeholder="..........."
                                            formik={formik}
                                            label="رمز عبور"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <button className="btn btn-primary d-grid w-100" type="submit"
                                        >ورود
                                            {
                                                isLoading && <Loading/>
                                            }
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
}